import { HStack, Pressable } from "@gluestack-ui/themed";
import { StoreSelectorProps, StoreSelectorVariantEnum } from "./types";
import { Text } from "@repo/core/components/core/Text";
import { Icon } from "@repo/core/components/core/Icon";

export const StoreSelector = ({
  selectedStore,
  onSelectStore,
  enableSelectStore,
  variant = StoreSelectorVariantEnum.BOTH
}: StoreSelectorProps) => {
  return (
    <Pressable onPress={onSelectStore} disabled={!enableSelectStore}>
      <HStack
        p="$2"
        alignItems="center"
        justifyContent="space-between"
        space="sm"
      >
        <Icon name="location-dot" color="$primary50" size={16} />
        {selectedStore && (
          <Text color="$white" fontSize="$xs" fontWeight={600}>
            {variant === StoreSelectorVariantEnum.SHOPKEEPER
              ? selectedStore.descrLojista
              : selectedStore?.descrLoja}
          </Text>
        )}
        {enableSelectStore && (
          <Icon name="chevron-down" color="$white" size={16} />
        )}
      </HStack>
    </Pressable>
  );
};
